module.exports = __webpack_public_path__ + "img/manage_nav_dark.280bc6e7.svg";